module.exports = __webpack_public_path__ + "dist/img/api.01c12e13.jpg";